import { createContext } from 'react'
import {
  IVoidCallback,
} from '@kaidam/fc-shared/src/types/utils'

interface IData_TextEditor_Context {
  focus: IVoidCallback,
  disableLinkClicks: boolean,
}

const TextEditorContext = createContext<IData_TextEditor_Context>({
  focus: () => {},
  disableLinkClicks: true,
})

export default TextEditorContext